<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row no-gutters>
            <v-col cols="3">Filtri</v-col>
            <v-col cols="8" class="text--secondary">
              <span  v-if="open" key="0">Imposta i filtri di visualizzazione</span>
              <span v-else key="1">
                <v-chip class="mr-1" v-for="x in unionFiltri" :key="x">{{ x }}</v-chip>
              </span>
            </v-col>
            <v-col cols="1" v-if="open"><v-btn @click.stop="onFiltra">Ricerca</v-btn></v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
         <v-row align="center" justify="space-around" dense>
          <v-col>
            <v-autocomplete
              v-model="filtro.codiceProdotto"
              :loading="loadingCodice"
              :items="codiciProdotto"
              :search-input.sync="searchCodice"
              cache-items
              class="mx-4"
              flat
              dense
              chips
              small-chips
              multiple
              hide-no-data
              hide-details
              outlined
              label="Codice prodotto"
              item-text="codice"
              item-value="codice"
              clearable
            >
<!--             <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 5" small-chips>
                <span>{{ item.codice }}</span>
              </v-chip>
              <span
                v-if="index === 5"
                class="grey--text text-caption"
              >
                (+altri {{ filtro.codiciProdotto.length - 5 }})
              </span>
            </template> -->
            </v-autocomplete>
            <!-- <v-select v-model="filtro.codiceProdotto" :items="codiciProdotto" chips flat outlined multiple label="Causale" item-text="descrizione" item-value="codice" clearable></v-select> -->
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="filtro.descrizione"
              :loading="loadindDescrizione"
              :items="descrizioni"
              :search-input.sync="searchDescrizione"
              cache-items
              class="mx-4"
              flat
              dense
              chips
              small-chips
              multiple
              hide-no-data
              hide-details
              outlined
              label="Descrizione"
              item-text="descrizione"
              item-value="descrizione"
              clearable
            ></v-autocomplete>
        </v-col>
        </v-row>
        <v-row align="center" justify="space-around" dense>
          <v-col>
            <v-select v-if="varianti1.length > 0" v-model="filtro.variante1" :items="varianti1" dense chips small-chips flat outlined multiple class="mx-4" label="Taglia" item-text="descrizione" item-value="codice" clearable hide-details></v-select>
          </v-col>
          <v-col>
            <v-select v-if="varianti2.length > 0" v-model="filtro.variante2" :items="varianti2" dense chips small-chips flat outlined multiple class="mx-4" label="Colore" item-text="descrizione" item-value="codice" clearable hide-details></v-select>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  import _ from 'lodash'
  import configurazioni from '@/services/configurazioniService.js'
  import prodotti from '@/services/prodottiService.js'
  import movimenti from '@/services/movimentiService.js'
  // ATTENZIONE: Sono filtri sui movimenti già letti --> devono funzionare solo su quello che è caricato, non su tutto l'archivio ....
  // ES. I prodotti sono solo quelli presenti nei movimenti, non nel db prodotti
  export default {
    props: {
      idParent: String,
      dataRef: String,
      tipoRef: String,
      aggiornaFiltri: Number,
      causale: String
      // movimenti: Array
    },
    data: (vm) => ({
      codiciProdotto: [],
      descrizioni: [],
      infoProdotti: {
        prodotti: [],
        varianti1: [],
        varianti2: []
      },
/*       varianti1: [],
      varianti2: [], */
      loading: false,
      items: [],
      search: null,
      searchCodice: null,
      searchDescrizione: null,
      select: null,
      loadingCodice: false,
      loadindDescrizione: false,
      filtro: {
        id: vm.idParent,
        data: vm.dataRef,
        tipo: vm.tipoRef,
        causale: vm.causale,
        codiceProdotto: [],
        descrizione: [],
        variante1: [],
        variante2: [],
        quantita: null,
        prezzo: null,
        acquisto: null
      },
      debounceSearchCodice: null,
      debounceSearchDescrizione: null
    }),
    created() {
      this.debounceSearchCodice = _.debounce(this.searchCodiceDeb, 500)
      this.debounceSearchDescrizione = _.debounce(this.searchDescrizioneDeb, 500)
    },
    async mounted() {
      this.onFiltra()
      await this.calcInfoProdotti()
    },
    computed: {
      unionFiltri() {
        return this.filtro.codiceProdotto.concat(this.filtro.descrizione).concat(this.filtro.variante1).concat(this.filtro.variante2)
      },
      varianti1() {
        const vr = this.infoProdotti && this.infoProdotti.varianti1
        return (vr && vr.length > 0) ? _.uniqBy(vr, 'codice') : []
      },
      varianti2() {
        const vr = this.infoProdotti && this.infoProdotti.varianti2
        return (vr && vr.length > 0) ? _.uniqBy(vr, 'codice') : []
      }
    },
    watch: {
      async searchCodice(val) {
        await this.debounceSearchCodice(val)
      },
      async searchDescrizione (val) {
        await this.debounceSearchDescrizione(val)
      },
      'filtro.codiciProdotto'() {
        this.searchCodice = ''
      },
      'filtro.descrizione'() {
        this.searchDescrizione = ''
      },
      async idParent(value) {
        this.filtro.id = value
        await this.$nextTick()
        this.filtro.variante1 = []
        this.filtro.variante2 = []
        this.onFiltra()
      },
      dataRef(value) {
        this.filtro.data = value
      },
      tipoRef(value) {
        this.filtro.tipo = value
      },
      causale(value) {
        this.filtro.causale = value
      },
      async aggiornaFiltri(value) {
        await this.calcInfoProdotti()
      }
    },
    methods: {
      async calcInfoProdotti() {
        if (!this.tipoRef || !this.idParent || !this.dataRef) return
        const idsp = await movimenti.getInfoProdotti(this.tipoRef, this.idParent, this.dataRef)
        const data = await prodotti.getProdottiByIds(_.uniq(idsp))
        const pp = data.map( x => { return {
          codice: x.codice,
          descrizione: x.descrizione
        }})
        let dv = data.filter(x => x.varianti && x.varianti.variante1 && x.varianti.variante1.codice)
        const varianti1 = dv.map(x => x.varianti.variante1)
        dv = data.filter(x => x.varianti && x.varianti.variante2 && x.varianti.variante2.codice)
        const varianti2 = dv.map(x => x.varianti.variante2)
        this.infoProdotti = {
          prodotti: pp,
          varianti1: _.uniqBy(varianti1, 'codice'),
          varianti2: _.uniqBy(varianti2, 'codice')
        }

      },
      async searchCodiceDeb(val) {
        const pr = this.filtro.codiceProdotto.filter(x => x === val)
        if (val && pr.length === 0) {
          await this.querySelections({ codice: val })
        }
      },
      async searchDescrizioneDeb(val) {
        const pr = this.filtro.descrizione.filter(x => x === val)
        if (val && pr.length === 0) {
          await this.querySelections({ descrizione: val })
        }
      },
      async querySelections (filtri) {
        this.loading = true
        // const cp = this.movimenti.map (x => x.prodotto)
        const cp = this.infoProdotti.prodotti
        // **********
        // Richiamare su mounted() movimenti.getInfoProdotti(riferimento.id) che ritorna prodotti[] (codice descrizione), varianti1[] e varianti2[] (codice, descrizione)
        // ***********
        if (filtri.codice) { // this.infoProdotti
          this.codiciProdotto = _.uniqBy(cp, 'codice').map(x => { return { codice: x.codice, descrizione: x.descrizione }})
        }
        if (filtri.descrizione) { // this.infoProdotti
          this.descrizioni = _.uniqBy(cp, 'descrizione').map(x => { return { codice: x.codice, descrizione: x.descrizione }})
        }
        this.loading = false
      },
/*       async querySelections (filtri) {
        this.loading = true
        const data = await prodotti.getFilteredProducts(filtri, null, 'v3')
        if (filtri.codice) {
          const cp = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []
          this.codiciProdotto = _.uniqBy(cp, 'codice').map(x => { return { codice: x.codice, descrizione: x.descrizione }})
        }
        if (filtri.descrizione) {
          const cp = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []
          this.descrizioni = _.uniqBy(cp, 'descrizione').map(x => { return { codice: x.codice, descrizione: x.descrizione }})
        }
        this.loading = false
      }, */
      onFiltra() {
        this.$emit('ricerca', this.filtro)
      },
      async getValues(source) {
        let elementi = []
        if (typeof source === 'string') {
          const config = source.split('.')
          const configId = config[0]
          const subId = config[1] || '' // TODO verificare
          const sub2 = config[2] || ''
          const sourceArray = await configurazioni.getConfigurazione(configId, subId)
          if (sub2) {
            elementi = sourceArray ? sourceArray.filter(x => x.tipo === sub2).map(x => { return { codice: x.codice, descrizione: x.descrizione } }) : []
          } else {
            elementi = sourceArray ? sourceArray.map(x => { return { codice: x.codice, descrizione: x.descrizione } }) : []
          }
        } else if (Array.isArray(source)) {
          elementi = [...source]
        }
        return elementi
      }
    }
  }
</script>
